// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__QZYQc","body":"dashboard_body__wTbnx","main":"dashboard_main__rOB4f","admin":"dashboard_admin__yR+re","manager":"dashboard_manager__VmC0u"};